import { Box, styled } from '@mui/material';

export const Container = styled(Box)`
  position: relative;
  width: 100%;
  height: 300px;
  margin-bottom: 20px;
`;

export const Wrapper = styled(Box)`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const Main = styled(Box)`
  display: flex;
  align-items: start;

  &:hover .delete-btn {
    opacity: 1;
  }
`;
